import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import phone from "../../../redux/slices/phone";

interface CallInfoDialogProps {
  isShown: boolean;
  setShown: Function;
  call: any;
  contacts: any[];
  onTestCallSubmit: Function;
}
export default function CallInfoDialog({
  isShown = false,
  setShown = () => {},
  call = undefined,
  contacts = [],
  onTestCallSubmit = () => {},
}: CallInfoDialogProps) {
  return (
    <Dialog
      open={isShown}
      onClose={() => setShown(false)}
      fullWidth={true}
      fullScreen={false}
      maxWidth={"md"}
    >
      <DialogTitle>
        Số điện thoại{" "}
        {call?.direction === "inbound"
          ? `${call?.fromNumber} đang
          gọi vào`
          : ""}
      </DialogTitle>
      <DialogContent>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell variant="head" rowSpan={2}>
                  Họ tên
                </TableCell>
                <TableCell variant="head" rowSpan={2}>
                  Mối quan hệ
                </TableCell>
                <TableCell variant="head" colSpan={3}>
                  Khách hàng
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell variant="head">Mã</TableCell>
                <TableCell variant="head">Họ tên</TableCell>
                <TableCell variant="head">Số điện thoại</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {contacts?.map((c: any, i: number) => {
                return (
                  <TableRow
                    key={i}
                    hover
                    sx={{
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      /* navigate(`/lcm/customer/${customer.id}`, {replace:true}); */
                      window.open(
                        `/lcm/customer/${c.customer.id}`,
                        "_blank",
                        ""
                      );
                    }}
                  >
                    <TableCell>{c.fullname}</TableCell>
                    <TableCell>{c.type}</TableCell>
                    <TableCell>{c.customer?.code}</TableCell>
                    <TableCell>{c.customer?.fullname}</TableCell>
                    <TableCell>{c.customer?.phonenumber}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      {true ? (
        <DialogActions>
          <Button
            variant="text"
            onClick={() => {
              setShown(false);
            }}
          >
            Đóng
          </Button>
          <Button variant="text" onClick={()=>{
            onTestCallSubmit()
          }}>
            Tải lại thông tin cuộc gọi
          </Button>
        </DialogActions>
      ) : (
        <React.Fragment />
      )}
    </Dialog>
  );
}
